<template>
  <div class="cmi-leicester">
    <div class="page-top">
      <div
        class="parallax"
        style="background:url(/dist/assets/images/ChurchImages/rupc_bg_006.png);"
      ></div>
      <div class="container">
        <h1><span class="title-span">RUPC</span> MONTREAL</h1>
        <ul>
          <li><router-link to="/" :exact="true">Home</router-link></li>
          <li><router-link to="/coventry/resources">Resources</router-link></li>
        </ul>
      </div>
    </div>
    <section>
      <div class="block cmi-section">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <h3 class="header">MANAGE COVENTRY RESOURCES</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-10 col-md-offset-1">
              <resources :baseUrl="'Coventry/Resources/'"></resources>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer-coventry></footer-coventry>
  </div>
</template>
<script>
export default {
  components: {
    Resources: () => import("./Resources"),
    FooterCoventry: () => import("./FooterCoventry")
  },
  data() {
    return {};
  }
};
</script>
